export const ENV = 'sandbox';

export const API_URL = 'https://api.us2.fusus.io';
export const REGION = 'US';


export const SECONDARY_API_URL = 'https://api.us2.fusus.io';
export const LPR_API = 'https://lpr-api.dev.fususone.com';


export const SENTRY_DSN = 'https://51d1a6073cff447eb51c8868d84fa2cd@sentry.io/1271085';

export const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyDOsX6PSC_V4MDmVwRNbK_8RHElxuiKWGw',
  authDomain: 'fieldwatch-dev.firebaseapp.com',
  databaseURL: 'https://fieldwatch-dev.firebaseio.com',
  projectId: 'fieldwatch-dev',
  storageBucket: 'fieldwatch-dev.appspot.com',
  messagingSenderId: '262238239191',
  appId: '1:262238239191:web:0524bbabeed7d9b5',
};

export const DEFAULT_MAP_SOURCE = 'google';
export const GOOGLE_MAP_KEY = 'AIzaSyAVf2z02JwhmKj6XTPysbNxSxlCJouX1Vo';

export const GOOGLE_RECAPTCHA_KEY = '6Le9os0UAAAAACJdxroKLVefCOcBjPFpypgPoafh';

export const GOOGLE_MAP_ID_LIGHT_2D = '150305ad89ca4900';
export const GOOGLE_MAP_ID_DARK_2D = 'b5786008baf3661e';

export const GOOGLE_MAP_ID_LIGHT_3D = '837780462c2c5abe';
export const GOOGLE_MAP_ID_DARK_3D = 'eed4c7219537e832';
export const GOOGLE_MAP_ID_TRANSIT = 'e9bcb0ff7c65640a';
export const GOOGLE_MAP_ID_DRAWING = '955620ed3261c373';
export const ESRI_PLATFORM_API_KEY = 'AAPTxy8BH1VEsoebNVZXo8HurOcjP1K4dFZ62u3E2Xp6xiesfITzugNOBzH_edtkzLfBXeiQwkhDyGxY--Sc0UuMuhHazjfIc3dGbVso6hcPXf5ERJFAAldmdCtNKoVwkCTk43JTYOe0LqhjbAoZEOdhAn98Xx-s974NaJN0PPvLH_sZZcrKdlUBPdx9jEaCP5ecg7rakZpw4AXBIwW50x8KfzAzwuvEeKlJ_MnlqY4ytgI.AT1_EaB0YsfU';


export const MAPBOX_KEY = 'pk.eyJ1Ijoic2VjdXJvbmV0IiwiYSI6ImNqeXRzdjVpdjA0d2kzZ3BnN3hqY3h4aXEifQ.GUC1QVhBXHwU4ncpNWrZdA';

export const WEATHERSTACK_KEY = '22a3842e3964e17d2e500ee9a144c04f';

export const HOST = 'meet.sandbox.fususone.com';
export const AXON_REGION = 'ag1';
export const AXON_EDC_URL = '.ag1.evidence.com';

export const FIRST_TWO_USERNAME = '7rnuj16kcumh';
export const FIRST_TWO_PASSWORD = '2b6a2211mqv8t4q58uf9kqk7e7';

export const AERIS_WEATHER_ACCESS_ID = '3akMJbOfmsA3rnFN3kxsW';
export const AERIS_WEATHER_KEY = 'U0akI8OFGf1e8zlnWdySGVaevz2pdcSe1sDWAxGG';

export const ADS_B_EXCHANGE_KEY = '2599f3ed59msh2bf7cf1a6461e14p1f663bjsnf99f1f3dc16c';

export const DATA_DOG_DASHBOARD_APP_ID = 'd9461008-76b4-4370-8058-97e76971ca9d';
export const DATA_DOG_DASHBOARD_CLIENT_TOKEN = 'pub6f64f44f3538abaf59c5dd618ff7ae06';

export const STRIPE_KEY = 'pk_test_51N0000000000000000000000000000000000';

export const PREPARED_911_API_URL = 'https://api.prepared911.com';
export const PREPARED_911_CLIENT_ID = 'NIZIJQ77ncV9C9kYHY4j-kGpffkFc7uOQwFwmj5Qz7E';
export const PREPARED_911_CLIENT_SECRET = '$2a$12$mydYcTeoJet3jchGHjtfWeIwwOZD.olZ597C6PwkSoJu55HssBBaW';
